// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"tJ_P3JjmqRC0CcR8bCwKl"};